import moment from "moment";
import type { Application } from "types/application";

type StageChange = NonNullable<Application["stage_changed"]>;

export const formatStageChange = ({ by, at }: StageChange) =>
  [by?.name, at ? moment(at).format("MMM D [at] h:mm A") : null]
    .filter(Boolean)
    .join(" · ");
